module.exports = __webpack_public_path__ + "img/yalda-m.1ece60e.svg";